import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvatarComponent } from '@components/common/avatar/avatar.component';
import { ToggleSmsComponent } from '@components/common/toggle-enable-sms/toggle-enable-sms.component';
import { ToggleGroupComponent } from '@components/common/toggle-group/toggle-group.component';
import { ToggleInteractionsComponent } from '@components/common/toggle-interactions/toggle-interactions.component';
import { SetWebhookFormComponent } from '@components/forms/set-webhook-form/set-webhook-form.component';
import { SpellCheckerDirective } from '@directives/spell-checker/spell-checker.directive';
import { MatIconModule } from '@node_modules/@angular/material/icon';
import { TranslateModule } from '@node_modules/@ngx-translate/core';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { BoucingDotsComponent } from './bouncing-dots/bouncing-dots.component';
import { CardListingComponent } from './card-listing/card-listing.components';
import { FlowChartComponent } from './flow-chart/flow-chart.component';
import { MultiListingComponent } from './multi-listing/multi-listing.component';
import { OmniDynamicPaginationModule } from './omni-dynamic-pagination/omni-dynamic-pagination.module';
import { OmniOptionsTogglerComponent } from './omni-options-toggler/omni-options-toggler.component';
import { ParticlesBackgroundComponent } from './particles-background/particles-background.component';
import { TableListingComponent } from './table-listing/table-listing.components';
import { TagGroupComponent } from './tag-group/tag-group.component';
import { ToggleWhatsappOmniComponent } from './toggle-whatsapp-omni/toggle-whatsapp-omni.component';
import { ToggleComponent } from './toggle/toggle.component';
import { ViewTogglerComponent } from './view-toggler/view-toggler.component';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { StepperComponent } from './stepper/stepper.component';
import { SimpleImageInputComponent } from './simple-image-input/simple-image-input.component';
import { TimerComponent } from '@modules/monitoring/agents/components/common/timer/timer.component';
import { PaginatedSelectorComponent } from './paginated-selector/paginated-selector.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@node_modules/@angular/material/checkbox';
import { TableListingFiltersComponent } from '@components/filters/table-listing-filters/table-listing-filters.component';
import { MatExpansionModule } from '@node_modules/@angular/material/expansion';
import { MatDatepickerModule } from '@node_modules/@angular/material/datepicker';

@NgModule({
  declarations: [
    ToggleInteractionsComponent,
    ToggleGroupComponent,
    ToggleWhatsappOmniComponent,
    AvatarComponent,
    TagGroupComponent,
    BoucingDotsComponent,
    ToggleSmsComponent,
    OmniOptionsTogglerComponent,
    ParticlesBackgroundComponent,
    FlowChartComponent,
    SpellCheckerDirective,
    TableListingComponent,
    TableListingFiltersComponent,
    CardListingComponent,
    ViewTogglerComponent,
    SetWebhookFormComponent,
    MultiListingComponent,
    StepperComponent,
    SimpleImageInputComponent,
    ToggleComponent,
    TimerComponent,
    PaginatedSelectorComponent,
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    OmniDynamicPaginationModule,
    PipesModule,
    MatMenuModule,
    CdkStepperModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatDatepickerModule,
  ],
  exports: [
    ToggleInteractionsComponent,
    ToggleGroupComponent,
    ToggleWhatsappOmniComponent,
    AvatarComponent,
    TagGroupComponent,
    BoucingDotsComponent,
    ToggleSmsComponent,
    OmniOptionsTogglerComponent,
    ParticlesBackgroundComponent,
    FlowChartComponent,
    SpellCheckerDirective,
    TableListingComponent,
    TableListingFiltersComponent,
    CardListingComponent,
    ViewTogglerComponent,
    MultiListingComponent,
    StepperComponent,
    SimpleImageInputComponent,
    ToggleComponent,
    MatTooltipModule,
    TimerComponent,
    PaginatedSelectorComponent,
  ],
})
export class ShareCommonComponentsModule {}
